export default "/_next/static/sounds/vanna_voicemail-ff6e7de79d088b7114ae31b6a5a98c28.mp3";